import { FormGroup, FormControl, Validators } from '@angular/forms';

// core
import { FlagsHelper } from '../../../core/library/flags-helper';

// own module
import { JssNodeAbstract } from './jss-tree-abstract';
import { JssTreeNodeType, JssControlType } from './jss-types';
import { JssEventSubject, JssEventType, JssRule } from './jss-subject';
import { JssObserver, JssEventData } from './jss-observers';
import { FormArray } from '@angular/forms/src/model';

export const enum JssLeafFlags {
   NULL = 0,      // for initialization
   INITIAL_VALUE_DEFINED = 1 << 1, // 2
   MAXIMUM_DEFINED = 1 << 2, // 4
   MINIMUM_DEFINED = 1 << 3, // 8
   REQUIRED_DEFINED = 1 << 4, // 16
   FORMAT_DEFINED = 1 << 5, // 32
   DEFAULT_DEFINED = 1 << 6, // 64 - defined in schema
   OPTIONS_MULTI = 1 << 7, // 128 - textarea
}

export class JssNodeLeaf extends JssNodeAbstract implements JssObserver {

   protected _jssControlType: JssControlType = 'UNDEFINED'; // controls: input, select, etc.
   protected _format = '';       // format of data, e.g. a string can be a date
   protected _leafFlags: JssLeafFlags = JssLeafFlags.NULL;
   protected _formControl: FormControl = null;
   protected _visible = true;
   protected _enabled = true;
   protected _valuePassThrough = false;
   protected _jssEventSubject: JssEventSubject = null;
   protected _jssRule: JssRule[] = [];

   constructor(
      nodeName: string,
      jssPropertyType: JssTreeNodeType,
      jssControlType: JssControlType = 'UNDEFINED'
   ) {
      super(nodeName, jssPropertyType);
      this._jssControlType = jssControlType;
   }

   // Flags
   public getLeafFlags(): JssLeafFlags {
      return this._leafFlags;
   }

   // Visibility
   public get visible(): boolean { return this._visible; }
   public get enabled(): boolean { return this._enabled; }

   public set enabled(enabled: boolean) {
      this._enabled = enabled;
   }

   // Pass-through
   public set valuePassThrough(flag: boolean) { this._valuePassThrough = flag; }
   public get valuePassThrough(): boolean { return this._valuePassThrough; }

   public set controlType(type: JssControlType) { this._jssControlType = type; }

   // formGroup
   public getFormControl(): FormControl { return this._formControl; }
   public getFormControlParent(): FormGroup | FormArray { return this._formControl.parent; }

   // Format
   public set format(value: string) {
      this._format = value;
      this._leafFlags = FlagsHelper.setFlag(
         this._leafFlags, JssLeafFlags.FORMAT_DEFINED, true);
   }
   public get format() { return this._format; }
   public hasFormat(): boolean {
      return FlagsHelper.isFlagSet(this._leafFlags, JssLeafFlags.FORMAT_DEFINED);
   }

   // Default
   public hasDefault(): boolean {
      return FlagsHelper.isFlagSet(this._leafFlags, JssLeafFlags.DEFAULT_DEFINED);
   }

   // Options
   public set optionMulti(show: boolean) {
      this._abstFlags = FlagsHelper.setFlag(this._abstFlags, JssLeafFlags.OPTIONS_MULTI, show);
   }
   public get optionMulti(): boolean {
      return FlagsHelper.isFlagSet(this._abstFlags, JssLeafFlags.OPTIONS_MULTI);
   }

   // events
   public registerObserver(
      eventType: JssEventType,
      jssObserver: JssObserver
   ): void {
      if (!this._jssEventSubject) {
         this._jssEventSubject = new JssEventSubject();
      }
      this._jssEventSubject.registerObserver(eventType, jssObserver);
   }
   public eventNotify(eventData: JssEventData): void {
      console.warn('JssNodeLeaf:eventNotify called -> not indented');
   }
   public eventRegisterRule(rule: JssRule) {
      this._jssRule.push(rule);
   }

   // Dump
   public recveDumpJssTree(indent: string) {
      console.log(indent + this._nodeName + '<' + this._nodeType + '>');
   }

   public recveGenFormTree(form: FormGroup) {
      // generate FormControl and add to parent FormGroup
      const newCtrl = this.isRequired() ?
         new FormControl('', Validators.required) :
         new FormControl('');
      form.addControl(this._nodeName, newCtrl);
   }

   /**
   * Erzeugt ein JS Object mit dem Inhalt der Form sowie den Hidden-pass-through Daten.
   *
   * @param data: any
   * @returns void
   */
   public recveCreateDataObject(data: any) {
   }

   public recveEvalSchema(dump_output: boolean) {
      // nothing to evaluate at this moment
   }
}



// WEBPACK FOOTER //
// /builds/cp/frap/t3/planer/src/app/core/json-form/model/jss-tree-leaf.ts